import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';

const Navbar = () => {
  const [toursOpen, setToursOpen] = useState(false);

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#ff8400',
      padding: '1.5rem 2rem',
      zIndex: 1000,
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
      display: 'flex',
      alignItems: 'center'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '1200px',
        margin: '0 auto',
        width: '100%'
      }}>
        {/* Desktop Navigation - Modern Black Buttons */}
        <div style={{
          display: 'flex',
          gap: '12px',
          alignItems: 'center'
        }} className="desktop-nav">
          <Link 
            to="/" 
            style={{
              color: 'white',
              textDecoration: 'none',
              padding: '0.7rem 1.8rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              letterSpacing: '0.3px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
            }}
          >
            Home
          </Link>

          {/* Cab Tours with Dropdown */}
          <div 
            style={{ position: 'relative' }}
            onMouseEnter={() => setToursOpen(true)}
            onMouseLeave={() => setToursOpen(false)}
          >
            <button
              style={{
                color: 'white',
                backgroundColor: '#1a1a1a',
                border: 'none',
                borderRadius: '8px',
                padding: '0.7rem 1.8rem',
                fontWeight: '600',
                fontSize: '0.95rem',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                letterSpacing: '0.3px',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#000000';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#1a1a1a';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
              }}
            >
              Cab Tours <span style={{ fontSize: '0.75rem' }}>{toursOpen ? '▲' : '▼'}</span>
            </button>
            
            {toursOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                backgroundColor: '#1a1a1a',
                minWidth: '220px',
                boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
                marginTop: '0rem',
                borderRadius: '8px',
                overflow: 'hidden',
                border: '1px solid rgba(255,255,255,0.1)'
              }}>
                <Link 
                  to="/cab-tours" 
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.9rem 1.5rem',
                    display: 'block',
                    transition: 'all 0.2s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#ff8400';
                    e.target.style.paddingLeft = '2rem';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '1.5rem';
                  }}
                >
                  All Tours
                </Link>
                <Link 
                  to="/cab-tours/murals-tour" 
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.9rem 1.5rem',
                    display: 'block',
                    transition: 'all 0.2s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#ff8400';
                    e.target.style.paddingLeft = '2rem';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '1.5rem';
                  }}
                >
                  Belfast Murals Tour
                </Link>
                <Link 
                  to="/cab-tours/belfast-political" 
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.9rem 1.5rem',
                    display: 'block',
                    transition: 'all 0.2s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#ff8400';
                    e.target.style.paddingLeft = '2rem';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '1.5rem';
                  }}
                >
                  Belfast Political Tour
                </Link>
                <Link 
                  to="/cab-tours/giants-causeway" 
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.9rem 1.5rem',
                    display: 'block',
                    transition: 'all 0.2s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#ff8400';
                    e.target.style.paddingLeft = '2rem';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '1.5rem';
                  }}
                >
                  Giant's Causeway Tour
                </Link>
                <Link 
                  to="/cab-tours/dark-hedges" 
                  style={{
                    color: 'white',
                    textDecoration: 'none',
                    padding: '0.9rem 1.5rem',
                    display: 'block',
                    transition: 'all 0.2s ease',
                    fontSize: '0.9rem',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#ff8400';
                    e.target.style.paddingLeft = '2rem';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.paddingLeft = '1.5rem';
                  }}
                >
                  Dark Hedges & Glens
                </Link>
              </div>
            )}
          </div>

          <Link 
            to="/tour-planning-tool" 
            style={{
              color: 'white',
              textDecoration: 'none',
              padding: '0.7rem 1.8rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              letterSpacing: '0.3px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
            }}
          >
            Tour Planner
          </Link>

          <Link 
            to="/blog" 
            style={{
              color: 'white',
              textDecoration: 'none',
              padding: '0.7rem 1.8rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              letterSpacing: '0.3px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
            }}
          >
            Blog
          </Link>

          <Link 
            to="/FAQs" 
            style={{
              color: 'white',
              textDecoration: 'none',
              padding: '0.7rem 1.8rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              letterSpacing: '0.3px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
            }}
          >
            FAQs
          </Link>

          <Link 
            to="/contact" 
            style={{
              color: 'white',
              textDecoration: 'none',
              padding: '0.7rem 1.8rem',
              fontWeight: '600',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#1a1a1a',
              borderRadius: '8px',
              letterSpacing: '0.3px',
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#000000';
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#1a1a1a';
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
            }}
          >
            Contact Us
          </Link>
        </div>

        {/* Mobile Navigation - Burger Menu */}
        <div className="mobile-nav" style={{ display: 'flex', alignItems: 'center' }}>
          <BurgerMenu />
        </div>
      </div>

      {/* Responsive styles */}
      <style>{`
        .desktop-nav {
          display: flex !important;
        }
        .mobile-nav {
          display: none !important;
        }
        
        @media (max-width: 768px) {
          nav {
            padding: 2.2rem 2rem !important;
          }
          .desktop-nav {
            display: none !important;
          }
          .mobile-nav {
            display: flex !important;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;